import { serverFetch } from "@core/server";

export function fetchHomeDashboard(signal) {
  return serverFetch("home", {}, signal);
}
